// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHsaAccountResponse
 */
export interface IHsaAccountResponse {
    /**
     * 
     * @type {number}
     * @memberof IHsaAccountResponse
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHsaAccountResponse
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IHsaAccountResponse
     */
    status?: IHsaAccountResponseStatusEnum | null;
    /**
     * 
     * @type {number}
     * @memberof IHsaAccountResponse
     */
    available_balance?: number;
}

/**
* @export
* @enum {string}
*/
export enum IHsaAccountResponseStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}


/**
 * Check if a given object implements the IHsaAccountResponse interface.
 */
export function instanceOfIHsaAccountResponse(value: object): value is IHsaAccountResponse {
    return true;
}

export function IHsaAccountResponseFromJSON(json: any): IHsaAccountResponse {
    return IHsaAccountResponseFromJSONTyped(json, false);
}

export function IHsaAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'number': json['number'] == null ? undefined : json['number'],
        'status': json['status'] == null ? undefined : json['status'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
    };
}

export function IHsaAccountResponseToJSON(json: any): IHsaAccountResponse {
    return IHsaAccountResponseToJSONTyped(json, false);
}

export function IHsaAccountResponseToJSONTyped(value?: IHsaAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'number': value['number'],
        'status': value['status'],
        'available_balance': value['available_balance'],
    };
}

